"use client"

import styled from "@emotion/styled"
import { Box } from "@mui/material"
import { useTranslations } from "next-intl"
import Image from "next/image"
import "swiper/css"
import { SwiperSlide } from "swiper/react"
import { mediaQueries, sizes, useIsDesktop } from "ui"
import CommonTitle from "../common/bit/CommonTitle"
import GeneralTextContent from "../common/bit/GeneralTextContent"
import BlockWrapper from "../common/BlockWrapper"
import InnerCardBoxItem from "../common/InnerCardBoxItem"
import SwiperOnMobile from "../SwiperOnMobile/SwiperOnMobile"

const StyledSwiper = styled(SwiperOnMobile)`
  ${mediaQueries.desktopM} {
    flex-flow: row wrap;
  }
`

const StyledSwiperSlide = styled(SwiperSlide)`
  &.swiper-slide {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 30px;
    border-radius: 30px;
    box-shadow: -8px 8px 30px 0px rgba(2, 1, 64, 0.08);
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(8px);
    width: 100%;
    height: 312px;
    ${mediaQueries.desktopM} {
      justify-content: flex-start;
      padding: ${sizes.baseTriple} ${sizes.baseOcto};
      width: 375px;
      height: 260px;
    }
    ${mediaQueries.desktopXl} {
      width: 506px;
    }
  }
`

const StyledBGImageContainer = styled(Box)`
  position: absolute;
  height: 80%;
  width: 80%;
  left: -13%;
  bottom: -7%;
  z-index: 0;
  img {
    object-fit: cover;
  }
  ${mediaQueries.mobile} {
    display: none;
  }
  ${mediaQueries.desktopM} {
    z-index: -1;
    inset: 0 -65px auto 0;
    width: 800px;
    height: 100%;
  }
  ${mediaQueries.desktop} {
    top: -56px;
    left: 0px;
  }
`
const StyledGeneralTextContent = styled(GeneralTextContent)`
  align-items: center;
  gap: 12px;
  p,
  h3 {
    width: 100%;
    text-align: center;
  }
  ${mediaQueries.mobile} {
    padding: 0 ${sizes.baseSingle};
  }
`

const SixCardsListSwiperMobile = ({ data, id }: any) => {
  const { title, itemsList, subtitle, bottomTitle, text, fax, mail } = data
  const isDesktop = useIsDesktop()
  const t = useTranslations("SEO")
  const formT = useTranslations("DynamicForms")
  const bottomData = {
    subtitle: { ...bottomTitle },
    text: { ...text },
    horizontalList: [
      { type: "fax", text: formT("fax"), value: fax?.value },
      { type: "mail", text: formT("mail"), value: mail?.value },
    ],
  }

  return (
    <BlockWrapper
      id={id}
      style={
        isDesktop
          ? { maxWidth: "1600px", gap: sizes.basePenta }
          : { padding: "40px 0", gap: sizes.basePenta }
      }
    >
      {(title || subtitle) && (
        <CommonTitle title={title?.value} subtitle={subtitle?.value} />
      )}
      <StyledSwiper
        swiperProps={{
          navigation: false,
          centeredSlides: false,
          loop: false,
          slidesPerView: 1,
          autoHeight: false,
        }}
      >
        {itemsList?.blocks?.map((item: any, i: number) => {
          return (
            <StyledSwiperSlide key={i}>
              <InnerCardBoxItem item={item} />
            </StyledSwiperSlide>
          )
        })}
      </StyledSwiper>
      <StyledBGImageContainer>
        <Image
          sizes="100vw"
          fill
          src={
            isDesktop
              ? "/hachsharaProtectClaim.svg"
              : "/hachsharaProtectClaimMobile.svg"
          }
          alt={`${t("backgroundImageAlt")}${title?.value}`}
        />
      </StyledBGImageContainer>
      {bottomData && <StyledGeneralTextContent data={bottomData} />}
    </BlockWrapper>
  )
}

export default SixCardsListSwiperMobile
